import axios from "axios";
import {
  getPreUrlAccordingToCart,
  SUCCESS
} from "../../constants/constant";
import { snpAxios } from "../global/api";


export const requestTestBaseFcmNotification = async (
    apiToken,
    baseUrl,
    activeShopHash,
    setLoader) => {
    try {
        if (setLoader) setLoader(true);
        const kUrl = `${baseUrl}${getPreUrlAccordingToCart(activeShopHash.cartType)}test-user-fcm-notification?apiToken=${apiToken}&shopHash=${activeShopHash.id}`;
        await snpAxios.get(kUrl);
        if (setLoader) setLoader(false);
    } catch (error) {
        console.error("requestTestBaseFcmNotification", error);
        if (setLoader) setLoader(false);
    }
}


export const setBaseFcmNotification = async (
    apiToken,
    baseUrl,
    activeShopHash,
    token,
    responseCb) => {
    try {
        const kUrl = `${baseUrl}${getPreUrlAccordingToCart(activeShopHash.cartType)}set-Fcm-notifcation?apiToken=${encodeURIComponent(apiToken)}&shopHash=${encodeURIComponent(activeShopHash.id)}&val=${encodeURIComponent(token)}`;
        const response = await axios.get(kUrl);
        if (response.data.status === SUCCESS) {
            console.info("[NOTIFICATION_TRACE] FCM_TOKEN_REGISTERED", {
                registered: Boolean(token),
                shopHash: activeShopHash.id,
            });
            if (responseCb) responseCb(true);
        } else {
            console.error("[NOTIFICATION_TRACE] FCM_TOKEN_REGISTRATION_REJECTED", response.data);
            if (responseCb) responseCb(false);
        }
    } catch (error) {
        console.error("[NOTIFICATION_TRACE] FCM_TOKEN_REGISTRATION_FAILED", error);
        if (responseCb) responseCb(false);
    }
}

export const getBaseNotificationCount = async (
    baseUrl,
    activeShopHash,
    responseCb) => {
    try {
        const kUrl = `${baseUrl}${getPreUrlAccordingToCart(activeShopHash.cartType)}get-notifcation-count?shopHash=${activeShopHash.id}`;
        const response = await axios.get(kUrl);
        if (response.data.status === SUCCESS) {
            if (responseCb) responseCb(response.data.jcJson.count);
        } else {
            if (responseCb) responseCb(0);
        }
    } catch (error) {
        console.error("getBaseNotificationCount", error);
        if (responseCb) responseCb(0);
    }
}

export const getBaseNotification = async (
    baseUrl,
    activeShopHash,
    read,
    menuCall,
    responseCb) => {
    try {
        const kUrl = `${baseUrl}${getPreUrlAccordingToCart(activeShopHash.cartType)}get-notifcations?shopHash=${activeShopHash.id}&read=${read}&onMenu=${menuCall}`;
        const response = await snpAxios.get(kUrl);
        if (response.data.status === SUCCESS) {
            if (responseCb) responseCb(response.data.jcJson.datas);
        } else {
            if (responseCb) responseCb([]);
        }
    } catch (error) {
        console.error("getBaseNotification", error);
        if (responseCb) responseCb([]);
    }
}

export const setBaseNotificationRead = async (
    baseUrl,
    apiToken,
    cartType,
    id) => {
    try {
        const kUrl = `${baseUrl}${getPreUrlAccordingToCart(cartType)}set-notifcation-read?apiToken=${apiToken}&id=${id}`;
        await axios.get(kUrl);
    } catch (error) {
        console.error("getBaseNotification", error);
    }
}
